module.exports = __webpack_public_path__ + "media/images/no_interviews-cbc6c3df8a574fda120a20acbe250c0a.svg";